import { useMemo } from 'react';
import { useSwiperSlide } from 'swiper/react';
import { getDoohPreloadTime } from '../../services/DoohPreloadTime';

/**
 * @function useIsOnActiveSlide
 * @description Determines if the current slide is active or if DOOH recording mode is enabled.
 *
 * This hook uses `useSwiperSlide` to check if the current slide is active.
 * If the component that is using this hook is not inside a swiper carousel it defaults to returning true.
 * It also checks the URL for the `DOOHpreloadTime` query parameter to
 * determine if DOOH recording is enabled, in which case it always returns true.
 *
 * @returns {boolean} True if the current slide is active or DOOH recording mode is enabled.
 */
export function useIsOnActiveSlide(): boolean {
  const slide = useSwiperSlide();

  const isDoohRecordingEnabled = useMemo(() => getDoohPreloadTime() !== -1, []);

  if (isDoohRecordingEnabled) {
    return true;
  }

  return slide ? slide.isActive : true;
}
